import useGetMembershipProduct from './useGetMembershipProduct';

interface IUsePrimeOffer {
  isPrimeAdded: boolean;
  isPrimeDataLoading: boolean;
}

const usePrimeOffer = (): IUsePrimeOffer => {
  const { data: isPrimeOfferAdded, loading: isPrimeDataLoading } =
    useGetMembershipProduct();
  const isPrimeAdded = !!isPrimeOfferAdded?.offerAdded.type;
  return { isPrimeAdded, isPrimeDataLoading };
};

export default usePrimeOffer;
